<template>
  <div class="campaign-form-container">
    <v-container>
      <v-layout row class="padding">
        <v-flex xs4 sm12 offset-sm3>
          <v-card
            class="mx-auto mt-4 pa-5 text-center text-no-wrap"
            max-width="1000"
            id="limited-products"
          >
            <div class="text-heading">
              <h2>Edit FinTalk Category</h2>
            </div>
            <v-card-text>
              <v-form v-model="valid" @submit.prevent lazy-validation>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="type"
                        label="Fintalk Category"
                        :error-messages="fintalkCategoryErrors"
                        outlined
                        dense
                        required
                        @input="$v.type.$touch()"
                        @blur="$v.type.$touch()"
                      >
                      </v-text-field>
                    </v-col>
                   <v-col cols="12" md="6">
                     <v-text-field
                     v-model="color"
                     label="Color Code"
                     @input="customColourError()"
                     :error-messages="colorError"
                     outlined
                     dense
                     required
                     >
                     </v-text-field>
                      <span v-bind:class="{'error-colour': isAddClassServerError}"></span>
                   </v-col>
                  </v-row>
                  <v-row>
                  <v-col cols="12" md="6">
                      <v-file-input
                        v-model="app_icon"
                        label="App icon"
                        outlined
                        dense
                        required
                        @input="$v.app_icon.$touch()"
                        @blur="$v.app_icon.$touch()"
                      >
                      </v-file-input>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-file-input
                        v-model="web_icon"
                        label="Web icon"
                        outlined
                        dense
                        required
                        @input="$v.web_icon.$touch()"
                        @blur="$v.web_icon.$touch()"
                      >
                      </v-file-input>
                    </v-col>
                    </v-row>
                  <v-row class="buttonbox">
                    <v-btn class="campaign-btn" @click="submit"> Save </v-btn>
                    <v-btn class="campaign-btn-clear" @click="back">
                      Cancel
                    </v-btn>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { VueEditor } from "vue2-editor";
import axios from "axios";

export default {
  name: "Editor",
  components: {
    VueEditor,
  },
  mixins: [validationMixin],

  validations: {
    type: { required },
    web_icon: { required },
    app_icon:{required},
  },
  data: () => ({
   web_icon:[],
   app_icon:[],
   type:'',
   color:'',
   isAddClassServerError:false,
   colorError:''
  }),
  computed: {
     fintalkCategoryErrors() {
      const errors = [];
      if (!this.$v.type.$dirty) return errors;
      !this.$v.type.required && errors.push("Add Category");
      return errors;
    },
  },

  mounted() {
    let id = this.$route.params.id;
    let token = localStorage.getItem("token");
    axios
      .get(process.env.VUE_APP_ROOT_API + "admin/fin-talk-categories/"+id, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        this.type = response.data.type;
        this.color = response.data.color;
        this.web_icon = response.data.web_icon;
        this.app_icon = response.data.app_icon;
      });
  },


  methods: {
    submit() {
      this.$loading(true);
      let id = this.$route.params.id;
      let token = localStorage.getItem("token");
      let formdata = new FormData();
      formdata.append("_method", "put");
      formdata.append("type", this.type);
      formdata.append("color", this.color);
      formdata.append("web_icon", this.web_icon);
      formdata.append("app_icon", this.app_icon);
      axios
        .post(
          process.env.VUE_APP_ROOT_API + "admin/fin-talk-categories/" +id,formdata,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + token,
            },
          }
        )
        .then((response) => {
          this.$loading(false);
          if (response.data.status == "success") {
            this.$router.push({ name: "ListFintalkCategory" }).catch(() => {});
            swal.fire({
              title: "Success!",
              text: "Record Added Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#051d42",
              confirmButtonText: "OK",
            });
          } else {
            this.error_message = "Invalid username or password.";
          }
        })
        .catch((error) => {
          this.$loading(false);
        });
    },
    customColourError(){
      const thisRegex = /#(([0-9a-fA-F]{2}){3,4}|([0-9a-fA-F]){3,4})/g.test(this.color)
      if(this.color == ""){
        this.colorError = '';
      }else if(thisRegex){
        this.colorError = '';
      }
      else{
        this.isAddClassServerError = true;
        this.colorError = 'Invalid Color Code';
      }
    },

   
    back() {
      this.$router.push({ name: "ListFintalkCategory" }).catch(() => {});
    },
  },
};
</script>
<style>
.error-colour{
  /* line-height: 12px; */
  /* word-break: break-word; */
  word-wrap: break-word;
  font-weight: bold;
  color: #ad2d2f;
  margin: 0px 0px 0px;
  display: flex;
  font-style: italic;
} 
</style>